module.exports = __webpack_public_path__ + "static/media/Template_1.1b9564d9.png";